// extracted by mini-css-extract-plugin
export default {"menu":"ApplicationSettings_menu__zQcC6"};